import { api } from './client';
import type { SubscriptionTier } from './auth';

export type BillingPeriod = 'Monthly' | 'Annual';

export interface BillingStatus {
  tier: SubscriptionTier;
  /** What the account may actually do now — trial and grace folded in. */
  effectiveTier: SubscriptionTier;
  status: string | null;
  onTrial: boolean;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  paymentFailed: boolean;
  graceUntil: string | null;
  hasPaymentMethod: boolean;
}

/** What Stripe will charge, in major units; the currency is whatever the price was created in. */
export interface BillingPrice {
  amount: number;
  currency: string;
}

export interface BillingPlan {
  tier: SubscriptionTier;
  period: BillingPeriod;
  configured: boolean;
  /** Null when billing is off or the amount could not be read — Checkout still states it. */
  price: BillingPrice | null;
  featuresBg: string[];
  featuresEn: string[];
}

export const billingApi = {
  status: () => api<BillingStatus>('/api/billing/status'),

  plans: () => api<BillingPlan[]>('/api/billing/plans'),

  checkout: (period: BillingPeriod) =>
    api<{ url: string }>('/api/billing/checkout', {
      method: 'POST',
      body: JSON.stringify({
        period,
        successUrl: `${window.location.origin}/billing?checkout=success`,
        cancelUrl: `${window.location.origin}/billing`,
      }),
    }),

  portal: () =>
    api<{ url: string }>('/api/billing/portal', {
      method: 'POST',
      body: JSON.stringify({ returnUrl: `${window.location.origin}/billing` }),
    }),
};
